import {Timestamp, FieldValue} from "firebase/firestore"

export interface ProviderProps {
  children?: React.ReactNode
}

export type SelectableUser = {
  uid: string,
  firstName: string,
  lastName: string,
  age: number,
}

export enum UserState {
  new,
  newOutstandingPayment,
  unapproved,
  approved,
  admin,
}

export enum UserClaimable {
  notClaimed         = 3,
  claimedNotApproved = 5,
  claimedAndApproved = 7,
}

export enum DayState {
  unknown = 3,
  markedAsScrubbed = 5,
  flownFlightsNotUploaded = 7,
  flownFlightsUploaded = 9,
}

export type CurrentUserInfoType = {
  uid : string,
  isApproved: boolean,
  isAdmin: boolean,
  isDriver: boolean,
  freeFlightID: string,
  passengerCount?: number,
  firstName: string,
  lastName: string,
  formSigned?: Date,
  dob?: Date,
  userState: UserState,
  fcmTokens?: Array<string>,
  phoneNumber?: string,
  owes?: number,
  lastFlew?: Timestamp,
  memberType?: MemberType,
  solo?: UserClaimable,
}

export type BankDetailsType = {
  fullName: string,
  sortCode: string,
  accountNumber: string,
  reference?: string,
}

export type AvailabilityData = {
  dateRequested: Timestamp,
  dateCreated: FieldValue,
  userFCMTokens: Array<string>,
  isDriver?: boolean,
  passengerCount?: number,
  firstName?: string,
  lastName?: string,
  owes?: number,
  lastFlew?: Timestamp,
  memberType?: MemberType,
  solo?: UserClaimable,
  email? : string,
  phoneNumber?: string,
}

export type ChangeableUserDetails = {
  firstName?: string,
  lastName?: string,
  driver?: boolean,
  passengerCount?: number,
  memberType?: MemberType,
  phoneNumber?: string,
  userState?: UserState,
  freeFlightID?: string,
  solo?: UserClaimable,
}

export type UserDetails = {
  uid: string,
  firstName: string,
  lastName: string,
  email?: string,
  dob: Date,
  isDriver?: boolean,
  passengerCount?: number,
  owes?: number, 
  lastFlew?: Date,
  memberType?: MemberType,
  phoneNumber?: string,
  userState?: UserState,
  freeFlightID?: string,
  solo?: UserClaimable,
}

export type UserInfo = UserDetails & {
  dateCreated: Date,
  dateRequested?: Date
  daysDriver?: boolean,
  final?: boolean,
}

export type FlyingListInfo = {
  flyingListDate: Date,
  availableUsers: Array<UserInfo>,
  currentFlyingList: Array<UserInfo>,
  final: boolean,
  dayState : DayState,
}

export type Airfield = {
  name: string,
  winchLaunchCost: number,
  winchTLFCost: number,
  winchRLFCost: number,
}

export enum MemberType {
  trial = "trial",
  home = "home",
  away = "away",
}
